import type { SVGProps } from "react";
export interface Flower02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Flower02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Flower02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12 .875c2.547 0 4.706 1.79 5.314 4.223 2.475-.154 4.77 1.429 5.544 3.875l.075.255c.632 2.376-.333 4.896-2.356 6.205.918 2.34.198 5.077-1.856 6.612a5.39 5.39 0 0 1-6.722-.2 5.39 5.39 0 0 1-6.504.354l-.217-.154c-2.053-1.535-2.773-4.273-1.856-6.612-2.094-1.356-3.054-4.01-2.28-6.459.772-2.446 3.068-4.03 5.543-3.876C7.292 2.664 9.454.875 12 .875m0 2.25c-1.617 0-3.036 1.27-3.215 3a1.46 1.46 0 0 1-1.602 1.313L7.02 7.41c-1.59-.345-3.214.593-3.735 2.24-.523 1.657.262 3.427 1.765 4.118l.144.074c.64.383.876 1.182.592 1.846l-.07.14c-.84 1.503-.434 3.41.909 4.414l.253.172c1.301.792 2.985.55 4.026-.636l.113-.117a1.457 1.457 0 0 1 1.964 0l.114.117.216.224a3.14 3.14 0 0 0 4.063.24l.24-.2c1.072-.972 1.411-2.573.81-3.928l-.143-.285a1.476 1.476 0 0 1 .666-2.061l.274-.143c1.235-.718 1.89-2.205 1.573-3.663l-.082-.312c-.488-1.544-1.945-2.465-3.436-2.29l-.299.05a1.46 1.46 0 0 1-1.739-1.132l-.023-.154c-.179-1.73-1.599-3-3.215-3ZM6.546 5.896l.002-.002v-.01z"
      />
      <path
        fill={color}
        d="M13.875 12.5a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m2.25 0a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0"
      />
    </svg>
  );
}
